<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <a v-if="$param('company.phone')"><strong>Tel: </strong>{{ $param('company.phone') }} | </a> 
      <a v-if="$param('company.address')"><strong>Adres: </strong>{{ $param('company.address') }} | </a>     
      <a v-if="$param('company.website.url')" :href="$param('company.website.url')"> {{ $param('company.website.url') }} | </a>
      Copyright© {{ new Date().getFullYear() }} - Sedbim | 
      <span class="d-none d-sm-inline-block"> Tüm hakları saklıdır.</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
